module.exports = __webpack_public_path__ + "static/img/bigmodel.e24f6af6.png";